<template>
	<div class="sliderScreeningPage visImage bigScreen" v-cloak>
		<div class="sliderScreening latticeBg visImageTop breadth fz14">
			<div>
				<span class="text marr8">时间</span>
				<div class="inlin sliderScreeningR">
					<el-date-picker
						class="time sliderDataCls"
						v-model="reportDate.data"
						type="monthrange"
						@change="datePicker"
						:picker-options="pickerOptions"
						unlink-panels
						range-separator="~"
						value-format="yyyy/MM"
						format="yyyy-MM"
						start-placeholder="开始时间"
						end-placeholder="结束时间"
					></el-date-picker>
				</div>
			</div>
		</div>
		<div>
			<el-row>
				<el-col :span="4">
					<div class="latticeBg breadth statistics" v-loading="countLoading">
						<el-row>
							<vis-two-number-grow :hospitalCountList="numberHospital"></vis-two-number-grow>
							<div class="fz14 mart23 center"><span class="marr20 dodgerBlue underline cur" @click="allPrevious()">查看历次质控结果</span></div>
						</el-row>
					</div>
					<vis-left-pie
						v-loading="pieLoading"
						class="latticeBg"
						:unqualifiedStatus="'false'"
						:tabType="GetReportListArr.tabType"
						:piestatus="'personal'"
						:name="visbreadcrumbList[1]"
					></vis-left-pie>
				</el-col>
				<el-col :span="20" class="pdl10">
					<el-row class="supervisorPages">
						<el-col :span="16" class="pdr10">
							<vis-tradar-charts
								v-loading="tradarLoading"
								class="mart0 notTabHeight"
								:percent="doctorCountLists.MoreThanRate"
								:title="`${visbreadcrumbList[1]}能力评估`"
								:suffix="'质控医生'"
								:colorList="['#64F2FF', '#2181FF']"
								:dataList="radarDoctorRadarList"
								:icon="'vispersonal'"
								:legendData="['影像中心', visbreadcrumbList[1] + '能力']"
							></vis-tradar-charts>
							<vis-portrait-line
								v-loading="portraitLoading"
								class="latticeBg mart10 barBoxHeight215"
								:icon="'iconvisunqualified'"
								:title="`月度${titleText}平均分`"
								:unit="'分'"
								:status="'personal'"
								tooltip="平均分"
								:unqualifiedStatus="'false'"
								:tabType="GetReportListArr.tabType"
								:chartsType="'line'"
								:colorList="['#2181FF', '#6BB1FF', '#2B5F53']"
								@movedoctorScoreMonthly="movedoctorScoreMonthly"
								:name="'movedoctorScoreMonthly'"
								:reportList="doctorScoreMonthly"
								:type="'score'"
							></vis-portrait-line>
						</el-col>
						<el-col :span="8">
							<vis-portrait-line
								v-loading="unqualifiedLoading"
								class="latticeBg barBoxHeight215"
								:icon="'iconvisunqualified'"
								:title="`月度不合格${titleText}`"
								:unit="'份'"
								:status="'personal'"
								:tooltip="`${titleText}数`"
								:unqualifiedStatus="'true'"
								:tabType="GetReportListArr.tabType"
								:chartsType="'bar'"
								:colorList="['#22B583', '#6bf4c6', '#2B5F53']"
								@moveunqualifiedMonthly="moveunqualifiedMonthly"
								:name="'moveunqualifiedMonthly'"
								:reportList="doctorURMonthlyList"
								:type="'count'"
							></vis-portrait-line>

							<div class="latticeBg mart10 pd10 tableBox tabletallHeight postr" v-loading="tableLoading">
								<div class="box"></div>
								<div class="title">
									<div class="inlin">
										<i class="iconfont iconvisunqualified tableIcon"></i>
										<span class="fz14">{{ visbreadcrumbList[1] }}{{titleText}}列表</span>
									</div>
								</div>
								<div v-if="reportList.Reports && reportList.Reports.length > 0">
									<div class="table">
										<el-table class="qcTable scrollbar" :data="reportList.Reports">
											<el-table-column prop="AccNo" min-width="120" label="报告编号" :show-overflow-tooltip="true"></el-table-column>
											<el-table-column prop="ChekingItems" label="检查项目" :show-overflow-tooltip="true"></el-table-column>
											<el-table-column prop="Score" label="得分"></el-table-column>
											<el-table-column prop="" label="操作" :key="4">
												<template slot-scope="scope">
													<span class="tableOpe" @click="handleClick(scope.row)">查看结果</span>
												</template>
											</el-table-column>
										</el-table>
									</div>
									<div class="pages">
										<el-pagination
											class="pageAll"
											layout="prev, pager, next"
											:total="reportList.TotalCount"
											:page-size="reportListParameter.pageCount"
											:current-page="reportListParameter.pageIndex"
											@current-change="currentChange"
										></el-pagination>
									</div>
								</div>
								<div v-else class="echartsNull">
									<div><svg-icon class="fz18 marr4" icon-class="icon-default-Nodata"></svg-icon></div>
									<div class="text">暂无数据</div>
								</div>
							</div>
						</el-col>
					</el-row>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
// import axios from "axios";
import visTwoNumberGrow from '../../components/visualization/visTwoNumberGrow';
import visLeftPie from '../../components/visualization/visLeftPie';
import visTradarCharts from '../../components/visualization/visTradarCharts';
import visPortraitLine from '@/components/visualization/visPortraitLine';
import visTable from '@/components/visualization/visTable';
// import { mapState, mapActions, mapMutations} from 'vuex'
export default {
	data() {
		return {
			pickerOptions: {
				shortcuts: [
					{
						text: '本月',
						onClick(picker) {
							picker.$emit('pick', [new Date(), new Date()]);
						}
					},
					{
						text: '今年至今',
						onClick(picker) {
							const end = new Date();
							const start = new Date(new Date().getFullYear(), 0);
							picker.$emit('pick', [start, end]);
						}
					},
					{
						text: '最近六个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setMonth(start.getMonth() - 6);
							picker.$emit('pick', [start, end]);
						}
					}
				],
				onPick: obj => {
					this.pickerMinDate = new Date(obj.minDate).getTime();
				},
				disabledDate: time => {
					if (this.pickerMinDate) {
						const day1 = 365 * 24 * 3600 * 1000;
						let maxTime = this.pickerMinDate + day1;
						let minTime = this.pickerMinDate - day1;
						return time.getTime() > maxTime || time.getTime() < minTime || time.getTime() > Date.now() - 1 * 24 * 3600 * 1000;
					} else {
						return time.getTime() > Date.now() - 1 * 24 * 3600 * 1000;
					}
				}
			},
			numberHospital: [],
			tabsSwitchArr: 2,
			dateVal: [],
			parameter: {},
			countLoading: false,
			pieLoading: false,
			tradarLoading: false,
			portraitLoading: false,
			unqualifiedLoading: false,
			tableLoading: false,
			titleText:'报告'
		};
	},
	components: {
		visTwoNumberGrow,
		visLeftPie,
		visTradarCharts,
		visPortraitLine,
		visTable
	},
	computed: {
		...Vuex.mapState('breadcrumb', ['breadLists', 'loading']),
		...Vuex.mapState('visualization', [
			'doctorCountLists',
			'reportDate',
			'doctorScoreMonthly',
			'doctorURMonthlyList',
			'doctorsAvgScore',
			'setDateArr',
			'technicianAvgScore',
			'getCountParameter',
			'radarDoctorRadarList',
			'reportList',
			'reportListParameter',
			'visbreadcrumbList',
			'doctorQCTaskParameter',
			'doctorbreadcrumbList'
		]),
		...Vuex.mapState('managerPlanList', ['qcresultsList']),
		...Vuex.mapState('supervisor', ['breadcrumbList', 'GetReportListArr']),
		...Vuex.mapState('login', ['dynamicValidateForm'])
	},
	activated() {
		// this.ChangeRole()
		this.reportDate.data = this.setDateArr.data;
		this.tabsSwitchArr = this.visbreadcrumbList[2];
		this.titleText = this.tabsSwitchArr==2?'报告':'影像'
		this.$nextTick(() => {
			let index = Number(this.breadLists.breadList.length);
			this.breadLists.breadList[index - 1].name = this.visbreadcrumbList[1] + '个人评估';
			this.callFunction(this.reportDate.data, this.visbreadcrumbList[2], this.visbreadcrumbList[1]);
			this.GetReportListArr.DoctorName = this.visbreadcrumbList[1];
		});
	},
	methods: {
		...Vuex.mapMutations('breadcrumb', ['setLoading', 'setqcresultsShow']),
		...Vuex.mapMutations('visualization', ['setreportDate', 'setvisBreadcrumbList', 'setdoctorbreadcrumbList']),
		...Vuex.mapMutations('doctor', ['setisSubmintflag','setIsSubmint', 'setDetalLoading', 'setDetailsParameter']),
		...Vuex.mapActions('visualization', ['GetDoctorCount', 'GetDoctorRadar', 'GetDoctorScoreMonthly', 'GetDoctorURMonthly', 'GetSummary', 'GetReportList', 'GetDoctorQCTask']),
		...Vuex.mapActions('managerPlanList', ['GetQCResultsByTask']),
		...Vuex.mapActions('doctor', ['GetReportDetail']),
		...Vuex.mapActions('login', ['ChangeRole']),
		getUriParam(key) {
		　　　　var variesObj = {},
		　　　　kAv = [],
		　　　　stringArr = window.location.search.substring(1).split("&");
		　　　　for (var i = 0; i < stringArr.length; i++) {
		　　　　　　kAv = stringArr[i].split("=");
		　　　　　　variesObj[kAv[0]] = kAv[1];
		　　　　}
		　　　　return variesObj[key];
		　　},
		// 跳转至详情页
		handleClick(val) {
			this.qcresultsList.Name = val.DoctorName;
			this.setqcresultsShow(false);
			this.qcresultsList.ExpertUserGuid = val.ExpertUserGuids[0];
			this.qcresultsList.ReportGuid = val.ReportGuid;
			this.qcresultsList.SamplingTaskGuid = val.SamplingTaskGuid;

			//详情不可编辑
			this.setIsSubmint(true);
			this.setisSubmintflag(true);
			this.setDetalLoading(true);
			this.setDetailsParameter({
				reportGuid: this.qcresultsList.ReportGuid,
				samplingTaskGuid: this.qcresultsList.SamplingTaskGuid,
				ExpertUserGuid: this.qcresultsList.ExpertUserGuid
			});
			this.GetQCResultsByTask({
				samplingtaskguid: this.qcresultsList.SamplingTaskGuid,
				reportGuid: this.qcresultsList.ReportGuid
			});
			// this.GetReportDetail();
			this.$router.push('/home/doctor/scoring');
		},
		setloadingList(flag) {
			this.countLoading = flag;
			this.pieLoading = flag;
			this.tradarLoading = flag;
			this.portraitLoading = flag;
			this.unqualifiedLoading = flag;
			this.tableLoading = flag;
		},
		setPar(dateVal, type) {
			this.reportListParameter.type = type;
			this.reportListParameter.pageIndex = 1;
			this.reportListParameter.pageCount = 10;
			this.reportListParameter.regionId = '';
			this.reportListParameter.startdt = dateVal[0];
			this.reportListParameter.enddt = dateVal[1];
			this.reportListParameter.doctorName = this.visbreadcrumbList[1];
			this.reportListParameter.hospitalGuid = this.GetReportListArr.hospitalGuid;
			this.reportListParameter.doctorGuid = this.GetReportListArr.DoctorGuid;

			this.doctorQCTaskParameter.hospitalGuid = this.GetReportListArr.hospitalGuid;
			this.doctorQCTaskParameter.startdt = dateVal[0];
			this.doctorQCTaskParameter.enddt = dateVal[1];
			this.doctorQCTaskParameter.type = type;
			this.doctorQCTaskParameter.name = this.visbreadcrumbList[1];

			this.getCountParameter.type = type;
			this.getCountParameter.doctorName = this.visbreadcrumbList[1];
		},
		callFunction(dateVal, type, doctorName) {
			let _this = this;
			_this.dateVal = dateVal;
			let dateList = {
				startdt: dateVal[0],
				enddt: dateVal[1],
				hospitalGuid: _this.GetReportListArr.hospitalGuid
			};

			
			_this.setPar(dateVal, type);
			// _this.setLoading(true);
			_this.setloadingList(true);
			this.GetDoctorCount({
				hospitalGuid: dateList.hospitalGuid,
				startdt: dateVal[0],
				enddt: dateVal[1],
				type: type,
				doctorName: doctorName
			}).then(res => {
				this.countLoading = false;
				this.numberHospital = [
					{
						number: this.doctorCountLists.QCedCount,
						icon: 'iconfont iconicon-Qualitycontrol visNumber',
						name: '质控次数',
						color: '#3D73DD',
						bgColor: '#344467',
						unit: '次'
					},
					{
						number: this.doctorCountLists.TotalReportCount,
						icon: 'iconfont iconvisReport visNumber',
						name: '报告',
						color: '#796EEE',
						bgColor: '#3F3F69',
						unit: '份'
					},
					{
						number: this.doctorCountLists.TotalRank,
						icon: 'iconfont iconvishomeranking visNumber',
						name: '总排名',
						color: '#30B4D9',
						bgColor: '#2A5464',
						unit: ''
					},
					{
						number: this.doctorCountLists.InRank,
						icon: 'iconfont iconvisinhospital visNumber',
						name: '院内排名',
						color: '#4AA8F1',
						bgColor: '#32506B',
						unit: ''
					},
					{
						number: this.doctorCountLists.TotalUnqualifiedCount,
						icon: 'iconfont iconvisunqualified visNumber',
						name: '不合格报告',
						color: '#9662FF',
						bgColor: '#493B6F',
						unit: '份'
					},
					{
						number: this.doctorCountLists.UnqualifiedRate,
						icon: 'iconfont iconvisrate visNumber',
						name: '不合格率',
						color: '#30D9A0',
						bgColor: '#2A5F53',
						unit: '%'
					}
				];
			});
			_this.GetSummary(dateList).then(res => {
				this.pieLoading = false;
			});
			_this.GetDoctorRadar({
				type: type,
				hospitalGuid: dateList.hospitalGuid,
				doctorName: doctorName,
				startdt: dateVal[0],
				enddt: dateVal[1]
			})
			.then(res => {
				this.tradarLoading = false;
			});
			_this.GetDoctorScoreMonthly({
				hospitalGuid: dateList.hospitalGuid,
				type: type,
				doctorName: doctorName,
				modalityType: '',
				bodyPart: '',
				scanType: '',
				startdt: dateVal[0],
				enddt: dateVal[1]
			}).then(res => {
				this.portraitLoading = false;
			});
			_this.GetDoctorURMonthly({
				hospitalGuid: dateList.hospitalGuid,
				type: type,
				doctorName: doctorName,
				modalityType: '',
				bodyPart: '',
				scanType: '',
				startdt: dateVal[0],
				enddt: dateVal[1]
			}).then(res => {
				this.unqualifiedLoading = false;
			});
			_this.GetReportList().then(res => {
				this.tableLoading = false;
			});
			// axios.all([]).then(axios.spread(function() {
			// 	_this.setLoading(false);
			// 	_this.$forceUpdate();
			// }));
		},
		datePicker(val) {
			this.setreportDate(val);
			this.callFunction(val, this.visbreadcrumbList[2], this.visbreadcrumbList[1]);
		},
		resetParameter() {
			this.parameter = {
				modalityType: '',
				bodyPart: '',
				scanType: '',
				startdt: '',
				enddt: '',
				hospitalGuid: '',
				doctorName: '',
				type: ''
			};
		},
		judgeParameter(item) {
			let _this = this;
			switch (item.type) {
				case 'all':
					_this.resetParameter();
					break;
				case 'modalityType':
					_this.resetParameter();
					_this.parameter.modalityType = item.name;
					break;
				case 'scanType':
					_this.resetParameter();
					_this.parameter.scanType = item.name;
					break;
				case 'bodypart':
					_this.resetParameter();
					_this.parameter.bodyPart = item.name;
					break;
				default:
					_this.resetParameter();
					break;
			}
			this.parameter.startdt = this.setDateArr.data[0];
			this.parameter.enddt = this.setDateArr.data[1];
			this.parameter.hospitalGuid = this.GetReportListArr.hospitalGuid;
			this.parameter.doctorName = this.visbreadcrumbList[1];
			this.parameter.type = this.visbreadcrumbList[2];
		},
		movedoctorScoreMonthly(item) {
			this.judgeParameter(item);
			this.portraitLoading = true;
			this.GetDoctorScoreMonthly(this.parameter).then(res => {
				this.portraitLoading = false;
			});
		},
		moveunqualifiedMonthly(item) {
			this.judgeParameter(item);
			this.unqualifiedLoading = true;
			this.GetDoctorURMonthly(this.parameter).then(res => {
				this.unqualifiedLoading = false;
			});
		},
		currentChange(val) {
			this.reportListParameter.pageIndex = val;
			this.tableLoading = true;
			this.GetReportList().then(res => {
				this.tableLoading = false;
			});
		},
		allPrevious() {
			this.setdoctorbreadcrumbList();
			this.doctorbreadcrumbList.push(this.reportDate.data[0] + '-' + this.reportDate.data[1]);
			this.doctorbreadcrumbList.push(this.visbreadcrumbList[1]);
			this.doctorbreadcrumbList.push('personal');
			this.GetDoctorQCTask().then(res => {
				this.$router.push('/home/visualization/visAllPrevious');
			});
		}
	}
};
</script>

<style></style>
